/* eslint-disable */
import React from 'react';
import TechnicianService from '../services/technicianService';

// Wrapper component สำหรับโหลด technician service
function TechnicianServiceWrapper({ children }) {
  // เรียกใช้ TechnicianService เพื่อ auto-load data
  TechnicianService();
  
  return children;
}

export default TechnicianServiceWrapper;